// Stripe configuration
// This file initializes the Stripe instance with your publishable key

import { loadStripe } from '@stripe/stripe-js';

const rawStripeKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
const stripePublishableKey =
  typeof rawStripeKey === 'string' ? rawStripeKey.trim() : '';
const normalizedStripeKey = stripePublishableKey.startsWith('pk_')
  ? stripePublishableKey
  : null;

// Initialize Stripe
export const stripePromise = normalizedStripeKey
  ? loadStripe(normalizedStripeKey)
  : Promise.resolve(null);

// Test card numbers for development
export const TEST_CARDS = {
  SUCCESS: '4242424242424242',
  DECLINE: '4000000000000002',
  INSUFFICIENT_FUNDS: '4000000000009995',
  REQUIRE_3DS: '4000002500003155',
};

export const TEST_BANK_ACCOUNT = {
  ACCOUNT_NUMBER: '000123456789',
  ROUTING_NUMBER: '110000000', // Valid test routing number
};
